import { createContext, useContext, useState, useEffect } from 'react'
import { useDatabase } from './DatabaseContext'
import { rtdb } from '../firebase'
import { ref, onValue, off,push,onChildAdded, set, remove } from 'firebase/database'
import { useAuth } from './AuthContext'

const TelemetryContext = createContext()

export function useTelemetry() {
    return useContext(TelemetryContext)
}

export function TelemetryProvider({ children }) {
    const { currentUser } = useAuth()
    const { carsSettings } = useDatabase()
    const { userSettings } = useDatabase()

    const [latestTelemetry, setLatestTelemetry] = useState({})
    const [telemetry, setTelemetry] = useState({})
    const FETCH_URL = 'https://ricecube.live/f24/data2'

    const fetchAndStore = async () => {
        try {
            const response = await fetch(FETCH_URL);
            const data = await response.json();

            if (data["Albyn1"] && data["Albyn1"]?.A !== undefined) {
                data["Albyn1"].A = Math.round((data["Albyn1"].A - 65.5) * 10) / 10;
            }
            if (data["Albyn3"] && data["Albyn3"]?.Vt !== undefined){
                data["Albyn3"].Vt = Math.round((data["Albyn3"]?.Vt - 5) * 10)/ 10;
            }
            setLatestTelemetry(data);
            console.log(userSettings)

            if (currentUser?.uid && userSettings && userSettings?.race_start_time) {
                Object.keys(data).forEach(carName => {
                    const carRef = ref(rtdb, `teams/${currentUser.uid}/${carName}`);
                    push(carRef, data[carName]);
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    const clearRealtimeDatabase = async() => {
        if (!currentUser?.uid) return;

        try {
            const telemetryRef = ref(rtdb, `teams/${currentUser.uid}`);
            await remove(telemetryRef);

            setTelemetry({});

        } catch (error) {
            console.log("Error clearing RTDB:", error);
        }
    }
    
    // Subscribe to the realtime database and get the latest telemetry packet
    useEffect(() => {
        if (!currentUser?.uid) return;

        const telemetryRef = ref(rtdb, `teams/${currentUser?.uid}`);
        const unsubscribeCallbacks = [];

        const unsubscribeValue = onValue(telemetryRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const history = {}
                Object.keys(data).forEach(carName => {
                    const readings = Object.values(data[carName] || []);
                    readings.sort((a,b) => (a?.["Timestamp"] || 0) - (b?.["Timestamp"] || 0))

                    history[carName] = readings

                    const carRef = ref(rtdb, `teams/${currentUser.uid}/${carName}`);
                    const unsubscribeChild = onChildAdded(carRef, (childSnapshot) => {
                        const newReading = childSnapshot.val();

                        setTelemetry(prev=> ({
                            ...prev,
                            [carName]: [...(prev[carName] || []), newReading]
                        }))

                        setLatestTelemetry(prev => ({
                            ...prev,
                            [carName]: newReading
                        }))
                    })
                    unsubscribeCallbacks.push(unsubscribeChild)
                })
                setTelemetry(history);
            }
        }, {onlyOnce: true});

        const interval = setInterval(fetchAndStore, 1000);

        return () => {
            unsubscribeValue();
            unsubscribeCallbacks.forEach(unsub => unsub());
            clearInterval(interval);
        }
    },[currentUser?.uid,userSettings?.race_start_time])

    const value = {
        telemetry, // All data
        latestTelemetry, // Object with latest data for each car
        clearRealtimeDatabase
    }

    return (
        <TelemetryContext.Provider value={value}>
            {children}
        </TelemetryContext.Provider>
    )
}